import http from "@/services/http";
import httpForm from "@/services/httpForm"

export const rental = () => {
  async function list() {
    const {data} = await http.get('/rental/list');
    return data;
  }

  async function getResume() {
    const {data} = await http.get('/rental/list');
    return data;
  }

  async function store(itemFormData) {
    const {data} = await httpForm.post('/rental/store', itemFormData);
    return data;
  }

  async function delet(id) {
    await http.put('/rental/delete/'+id,{});
    return true;
  }

  async function sendMovimentacao(id, status, type, note, description, photos) {
    await httpForm.post('rental/updateStatus/' + id, {status: status, type: type, note: note, description: description, photos: photos});
    return true;
  }

  async function update(itemFormData) {
    await http.post('/rental/edit', itemFormData);
    return true;
  }

  async function getOne(id) {
    const {data} = await http.get('/rental/getOne/'+id);
    return data;
  }

  async function findByCode(code) {
    const {data} = await http.get('/rental/findByCode/'+encodeURIComponent(code));
    return data;
  }

  return {list, store, delet, update, getOne, sendMovimentacao, getResume, findByCode};
}
